// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/bg_youshi.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/split.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/ercode.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.online-exp {
    padding: 0.52083rem 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
}
.online-exp .title {
    color: #fff;
}
.online-exp-list {
    display: flex;
    flex-wrap: wrap;
    width: 7.29167rem;
    margin: 0 auto;
    justify-content: space-between;
}
.online-exp-list-item {
    width: 3.48958rem;
    /* height: 422px; */
    background-color: #fff;
    padding: 0.26042rem;
    box-sizing: border-box;
}
.online-exp-list-item-title {
    font-size: 0.125rem;
    color: #474D58;
    font-weight: 600;
}
.online-exp-list-item-url {
    display: block;
    text-align: left;
    font-weight: 400;
    margin-top: 0.20833rem;
    background: #F2F7FE;
    /* height: 60px; */
    /* line-height: 60px; */
    font-size: 0.10417rem;
    color: #2475EE;
    text-decoration: underline;
    padding: 0.10417rem 0 0.10417rem 0.26042rem;
    
}

.exp-account-info {
    display: flex;
    margin-top: 0.10417rem;
}
.exp-account-split {
    /* width: 490px; */
    height: 0.00521rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    margin: 0.10417rem auto;
}
.exp-account-info-name {
    width: 1.14583rem;
    text-align: right;
    color: #ACB3BF;
    font-size: 0.10417rem;
}
.exp-account-info-value {
    color: #6F7783;
    font-size: 0.10417rem;
}
.online-exp-list-ercode {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    width: 1.21875rem;
    height: 1.21875rem;
    background-size: contain;
    margin: 0.20833rem auto;
}

@media screen and (max-width: 700px) {
     .exp-account-info-name, .exp-account-info-value, .online-exp-list-item-url, .online-exp-list-item-title { 
        font-size: 0.21875rem;
    }
    .online-exp-list {
        width: 9.375rem;
    }
    .online-exp-list-item-url {
        padding: 0.10417rem 0 0.10417rem 0.52083rem;
    }
    .online-exp-list-item {
        width: 4.58333rem;
    }
    .ercode {
        width: 3.125rem;
    }
    .manageplatform {
        width: 5.98958rem;
    }
    .exp-account-info-name {
        width: 2.08333rem;
    }
    .online-exp-list-ercode {
        width: 1.89583rem;
        height: 1.89583rem;
        margin-top: 0.26042rem;        
    }
}
 @media screen and (max-width: 400px) { 
      .exp-account-info-name {
        width: 3.125rem;
    }
 }`, "",{"version":3,"sources":["webpack://./src/components/OnlineExp/OnlineExp.css"],"names":[],"mappings":"AAAA;IACI,qBAAkB;IAClB,yDAA0D;IAC1D,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,eAAe;IACf,iBAAa;IACb,cAAc;IACd,8BAA8B;AAClC;AACA;IACI,iBAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,mBAAa;IACb,sBAAsB;AAC1B;AACA;IACI,mBAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,sBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAe;IACf,cAAc;IACd,0BAA0B;IAC1B,2CAA2B;;AAE/B;;AAEA;IACI,aAAa;IACb,sBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAW;IACX,yDAAsD;IACtD,uBAAiB;AACrB;AACA;IACI,iBAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,qBAAe;AACnB;AACA;IACI,cAAc;IACd,qBAAe;AACnB;AACA;IACI,yDAAuD;IACvD,iBAAY;IACZ,kBAAa;IACb,wBAAwB;IACxB,uBAAiB;AACrB;;AAEA;KACK;QACG,qBAAe;IACnB;IACA;QACI,eAAa;IACjB;IACA;QACI,2CAA4B;IAChC;IACA;QACI,iBAAY;IAChB;IACA;QACI,eAAY;IAChB;IACA;QACI,iBAAa;IACjB;IACA;QACI,iBAAY;IAChB;IACA;QACI,iBAAY;QACZ,kBAAa;QACb,sBAAgB;IACpB;AACJ;CACC;MACK;QACE,eAAY;IAChB;CACH","sourcesContent":[".online-exp {\n    padding: 100px 0px;\n    background-image: url('../../assets/images/bg_youshi.png');\n    background-size: cover;\n}\n.online-exp .title {\n    color: #fff;\n}\n.online-exp-list {\n    display: flex;\n    flex-wrap: wrap;\n    width: 1400px;\n    margin: 0 auto;\n    justify-content: space-between;\n}\n.online-exp-list-item {\n    width: 670px;\n    /* height: 422px; */\n    background-color: #fff;\n    padding: 50px;\n    box-sizing: border-box;\n}\n.online-exp-list-item-title {\n    font-size: 24px;\n    color: #474D58;\n    font-weight: 600;\n}\n.online-exp-list-item-url {\n    display: block;\n    text-align: left;\n    font-weight: 400;\n    margin-top: 40px;\n    background: #F2F7FE;\n    /* height: 60px; */\n    /* line-height: 60px; */\n    font-size: 20px;\n    color: #2475EE;\n    text-decoration: underline;\n    padding: 20px 0px 20px 50px;\n    \n}\n\n.exp-account-info {\n    display: flex;\n    margin-top: 20px;\n}\n.exp-account-split {\n    /* width: 490px; */\n    height: 1px;\n    background-image: url('../../assets/images/split.svg');\n    margin: 20px auto;\n}\n.exp-account-info-name {\n    width: 220px;\n    text-align: right;\n    color: #ACB3BF;\n    font-size: 20px;\n}\n.exp-account-info-value {\n    color: #6F7783;\n    font-size: 20px;\n}\n.online-exp-list-ercode {\n    background-image: url('../../assets/images/ercode.png');\n    width: 234px;\n    height: 234px;\n    background-size: contain;\n    margin: 40px auto;\n}\n\n@media screen and (max-width: 700px) {\n     .exp-account-info-name, .exp-account-info-value, .online-exp-list-item-url, .online-exp-list-item-title { \n        font-size: 42px;\n    }\n    .online-exp-list {\n        width: 1800px;\n    }\n    .online-exp-list-item-url {\n        padding: 20px 0px 20px 100px;\n    }\n    .online-exp-list-item {\n        width: 880px;\n    }\n    .ercode {\n        width: 600px;\n    }\n    .manageplatform {\n        width: 1150px;\n    }\n    .exp-account-info-name {\n        width: 400px;\n    }\n    .online-exp-list-ercode {\n        width: 364px;\n        height: 364px;\n        margin-top: 50px;        \n    }\n}\n @media screen and (max-width: 400px) { \n      .exp-account-info-name {\n        width: 600px;\n    }\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
